// extracted by mini-css-extract-plugin
export default {"question":"Question_question__JEPLI","title":"Question_title__axldk","message":"Question_message__zux7d","block":"Question_block__LbsV1","content":"Question_content__dyWDP"};